module.exports = __webpack_public_path__ + "media/assets/images/logo-cba-5d730191902740d6625e33a99cd6093d.svg";